// extracted by mini-css-extract-plugin
export default {"description":"ThirdScreen_description__okVz5","title":"ThirdScreen_title__LFW4K"};